import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { buildQueryParams, getReservations, cancelReservation } from "../api/reservationsAPI"
import { Rides } from "../../types/reservationsTypes"

export type ReservationsState = {
  reservationsList: Rides,
  loading: boolean,
  error: string | null,
}

const initialState: ReservationsState = {
  reservationsList: [],
  loading: false,
  error: null,
}

export const getReservationsAsync = createAsyncThunk<void, any>(
  "auth/getReservations",
  async ({ selectedMonth, page, count, isPast, locale }) => {
    const queryParams = buildQueryParams(
      selectedMonth,
      page,
      count,
      isPast,
      locale,
    )

    const response: any = await getReservations(queryParams)
    return response
  },
)

export const cancelReservationAsync = createAsyncThunk<void, any>(
  "auth/cancelReservation",
  async ({ reservationId, projectId }) => {

    const response: any = await cancelReservation(reservationId, projectId)
    window.location.reload();
    return response
  },
)

export const reservationsSlice = createSlice({
  name: "reservations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReservationsAsync.pending, (state) => {
      return { ...state, loading: true }
    });
    builder.addCase(getReservationsAsync.rejected, (state, action) => {
      return { ...state, error: "error in getting reservations" }
    });
    builder.addCase(
      getReservationsAsync.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.reservationsList = action.payload;
        state.error = null;
      },
    )
  },
})

export const selectReservationsList = (state: RootState) =>
  state.reservations

export default reservationsSlice.reducer
